import React from 'react';
// COMMENTED OUT FOR SURVEY BANNER
// import React, { useState } from "react";
import { Helmet } from 'react-helmet';
// COMMENTED OUT FOR SURVEY BANNER
// import { ReactComponent as CloseMenu } from "../images/components/Navbar/x.svg";
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";
import { Navigation } from 'swiper';
import useIsMobile from '../hooks/useIsMobile.js';

import SponsorAndPartnerLogos from "../components/universal/SponsorAndPartnerLogos/SponsorAndPartnerLogos.js";
import LevelCard from "../components/pages/get_started/LevelCard.js";
import "./GetStarted.css";
import SurveyFooter from "../components/universal/SurveyFooter/SurveyFooter.js";

import GetAllLevelInfo from "../hooks/getAllLevelInfo.js";
import Loading from "./Loading";
import Error from "./Error";

// COMMENT OUT FOR NOT CHRISTMAS
// import christmas_snowman from "../images/pages/christmas/christmas_snowman.svg";

function GetStarted(props) {
    const isMobile = useIsMobile(650);

    // set up the different courses available
    const python_course = props.legacy ? "python-legacy" : "python";
    const courses = [
        { id: python_course, title: "Python Fundamentals" },
        { id: "web-development", title: "Web Development Tutorials" },
        { id: "apis-with-python", title: "APIs with Python" }
    ];

    // get all level card information for each course
    const courseData = courses.map(course => ({
        ...course,
        ...GetAllLevelInfo(course.id)  // merges {all_level_card_information, loading}
    }));

    // COMMENTED OUT FOR SURVEY BANNER
    // const [showNewsBanner, setShowNewsBanner] = useState(true);
    // const dismissNewsBanner = () => setShowNewsBanner(false);

    if (courseData.some(c => c.loading)) {
        return <Loading />;
    } else if (courseData.some(c => (!c.loading && c.all_level_card_information.length === 0))) {
        return <Error />;
    } else {
        return (
            <div>
                <Helmet>
                    <title>Tutorials | Get started with Mission Encodeable</title>
                    <meta
                        name="description"
                        content="Choose a coding tutorial, and get started with Mission Encodeable. Each level contains interactive coding exercises, quizzes and projects."
                    />
                </Helmet>

                <div className="get-started-page-contents">
                    <section className="get-started-header">
                        <h1>Get started</h1>
                        <p>
                            {props.legacy
                                ? "This is an archive of our legacy tutorials, and will be available to view until September 2024 only. If starting Mission Encodeable's courses, we strongly recommend using the new tutorials."
                                : "Begin your coding journey with our Python and web development tutorials."}
                        </p>
                        <SponsorAndPartnerLogos align="center" colourway="light" />
                    </section>

                    {/* Loop over each course */}
                    {courseData.map(course => (
                        <section
                            key={course.id}
                            className={`${course.id}_tutorials`}
                            id={`${course.id}_tutorials`}
                        >
                            <h3 className="python-tutorials-subheading">{course.title}</h3>

                            <div className="get-started-swiper-container">
                                <Swiper
                                    key={isMobile ? `mobile-${course.id}` : `desktop-${course.id}`}
                                    slidesPerView={1}
                                    navigation
                                    spaceBetween={10}
                                    pagination={{
                                        ...(isMobile && {
                                            dynamicBullets: true,
                                            dynamicMainBullets: 5,
                                        }),
                                        clickable: true,
                                        renderBullet: function (index, className) {
                                            return (
                                                '<span class="' +
                                                className +
                                                '"><img class="pagination-bullet" alt=""/></span>'
                                            );
                                        },
                                    }}
                                    breakpoints={{
                                        485: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 20 },
                                        650: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 20 },
                                        875: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 20 },
                                        1000: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 20 },
                                        1230: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 20 },
                                        1900: { slidesPerView: 5, slidesPerGroup: 5, spaceBetween: 20 },
                                    }}
                                    modules={[Pagination, Navigation]}
                                    className="levelCardSwiper"
                                >
                                    {course.all_level_card_information.map((card, index) => (
                                        <SwiperSlide key={index}>
                                            <LevelCard
                                                course_type={course.id}
                                                levelNumber={index + 1}
                                                levelDescription={card.level_description}
                                                project_one={card.class_project}
                                                project_two={card.challenge_project}
                                            />
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </section>
                    ))}

                    {/* CHRISTMAS PROMO BLOCK - MUST DELETE AFTER CHRISTMAS! */}
                    {/* <section className="christmas-ad-section">
                        <div className="christmas-ad-block">
                            <div>
                                <h6>Looking for more Python fun?</h6>
                                <h1>Check out our Christmas coding challenges!</h1>
                                <Link to={'/christmas'}>
                                    <button className="christmas-project-btn-red wide-btn">
                                        See the Challenges
                                    </button>
                                </Link>
                            </div>
                            <img
                                src={christmas_snowman}
                                alt="A Christmas snowman, surrounded with snowflakes."
                            />
                        </div>
                    </section> */}

                    <SurveyFooter />
                </div>
            </div>
        );
}
}

export default GetStarted;
